module.exports = __webpack_public_path__ + "static/media/daysa-yoshida.cebe931e.jpeg";